<template>
  <div class="gs-app gm-suppression-table pb-4">
    <div class="gm-suppression-table__surface gs-refresh-controls flex mb-4">
      <div class="w-full">
        <server-table
          class="text-center groovemail-suppresors-table"
          ref="serverTable"
          :url="suppressorDataUrl"
          :tableRef="'suppressorsTable'"
          :slotData="suppressorsTableSlotData"
          :tableColumns="suppressorsTableColumns"
          :tableOptions="suppressorsTableOptions"
          :tableTitle="tableTitle"
          :addNewBtnText="addSuppressorBtnText"
          :uploadFileBtnText="'frontend_groovemail_components_suppressions_suppressors_add_suppressors_via_import'"
          :buttonViaImport="suppressorButtonViaImport"
          :downloadSampleFileBtnText="'frontend_groovemail_admin_block_sample_file'"
          @downloadSampleFile="downloadSampleForAddingSuppressors"
          @onFileChange="onFileChange"
          @addNewData="openAddSuppressorsModal"
          @loaded="hideLoader()"
          @loading="showLoader()"
        >
        </server-table>
      </div>
    </div>
    <gd-modal
      id="suppressorModal"
      name="suppressors-modal"
      :title="$t(addSuppresorModalTitle)"
    >
      <div class="p-6">
        <div class="mb-6">
          <text-area
            variant="base"
            v-model="model.data"
            :placeholder="$t(suppressorModalPlaceholder)"
            rows="5"
          />
          <div class="flex items-center text-sm text-dark mt-2">
            <span class="fa fa-info-circle mr-2"></span>
            {{ $t(suppressorModalNote) }}
          </div>
        </div>
        <div class="flex justify-end">
          <gs-button
            variant="outline"
            size="md"
            @click="closeAddSuppressorsModal()"
          >
            {{ $t('frontend_cancel') }}
          </gs-button>
          <gs-button
            variant="primary"
            :disabled="model.data.length < 1"
            size="md"
            class="ml-2"
            @click="addSuppresors()"
          >
            {{ $t('frontend_save') }}
          </gs-button>
        </div>
      </div>
    </gd-modal>

    <!-- Confirmation move modal -->
    <confirm-modal
      :ref="`confirmation-delete-suppressors`"
      :name="`confirmation-delete-suppressors`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_components_suppressions_are_you_sure_remove_suppressor')"
      @confirm="removeSuppressorsData"
      @close="closeDeleteSuppressorsModal"
    />


    <!-- Confirmation import csv -->
    <confirm-modal
      :ref="`confirmation-import-csv`"
      :name="`confirmation-import-csv`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_suppressions_are_you_sure_upload')"
      @confirm="confirmFileChnage"
      @close="closeFileChnageConfirm"
    />
  </div>
</template>

<script>
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import { postData, deleteData } from '@/utils/apiHelper.js';
import downloadCsvFile from '@/components/downloadCsvFile.js';
import monthsMixin from '@/mixin/monthsMixin';

import { showRequestErrorAlert } from '@/components/showDialog.js';


export default {
  mixins: [monthsMixin],

  props: {
    from: {
      required: true,
    },
    addSuppressorBtnText: {
      required: true,
    },
    suppressorsTableColumns: {
      required: true,
    },
    suppressorsTableOptions: {
      required: true,
    },
    suppressorDataUrl: {
      required: true,
    },
    suppressorDataUploadUrl: {
      required: true,
    },
    suppressorSampleDownloadUrl: {
      required: true,
    },
    addSuppresorModalTitle: {
      required: true,
    },
    suppressorModalNote: {
      required: true,
    },
    suppressorModalPlaceholder: {
      required: true,
    },
    tableTitle: {
      required: true,
    },
  },
  data() {
    return {
      tableKey: 1,
      suppressorsPayload: [],
      model: {
        data: '',
      },
      suppresorsData: [],
      suppressorId: null,
      confirmFileTarget: null,
    };
  },

  components: {
    ServerTable,
  },

  methods: {
    // show loader
    showLoader() {
      this.$emit('showLoader');
    },

    // hide loader
    hideLoader (){
      this.$emit('hideLoader');
    },

    // It is used to download sample csv file.
    async downloadSampleForAddingSuppressors() {
      await downloadCsvFile(
        this.suppressorSampleDownloadUrl,
        null,
        `suppressor-${this.from}.csv`
      );
    },

    // It is used to open suppression creation modal.
    openAddSuppressorsModal() {
      this.$root.$emit('modal-open', 'suppressors-modal');
      this.model.data = '';
    },

    // It is used to close suppression creation modal.
    closeAddSuppressorsModal() {
      this.$root.$emit('modal-close', 'suppressors-modal');
    },

    // It is used to upload suppression data.
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;

      // set the file target
      this.confirmFileTarget = files;


      if (!files.length) return;

      // open the modal
      this.$refs[`confirmation-import-csv`].open();
    },
    
    // confirm file change
    async confirmFileChnage() {
      const formData = new FormData();
      formData.append('csv', this.confirmFileTarget[0]);

      try {
        await postData(this.suppressorDataUploadUrl, formData);
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }

      this.$refs.serverTable.$refs.suppressorsTable.refresh();
  
      document.getElementById('upload').value = '';
    },

    // close confirm file change
    closeFileChnageConfirm() {
      this.confirmFileTarget = null;
    },


    // Function used to add new supression using textarea.
    async addSuppresors() {
      if (this.model.data.trim()) {
        const suppressorData = this.model.data.trim();
        const splitted = suppressorData.split('\n');
        splitted.forEach((element) => {
          if (element.trim()) {
            this.suppressorsPayload.push(element.trim().toLowerCase());
          }
        });
        let payload;
        if (this.from === 'email') {
          payload = {
            suppressionEmails: this.suppressorsPayload,
          };
        } else if (this.from === 'domain') {
          payload = {
            suppressionDomains: this.suppressorsPayload,
          };
        } else if (this.from === 'tld') {
          payload = {
            suppressionTlds: this.suppressorsPayload,
          };
        }

        // show loader
        this.showLoader();

        try {
          // add suppression data
          await postData(this.suppressorDataUrl, payload);
          this.closeAddSuppressorsModal();
          this.model.data = '';
          this.suppressorsPayload = [];
          payload = {};

          // refresh suppressors listing
          this.$refs.serverTable.$refs.suppressorsTable.refresh();
        } catch (error) {
          // show error alert
          showRequestErrorAlert(error?.response?.data?.error);
        }
      }
    },

    // open move suppressors modal
    async openDeleteSuppressorsModal(dataId) {
      // set the suppressors
      this.suppressorId = dataId;

      // open the modal
      this.$refs[`confirmation-delete-suppressors`].open();
    },

    // close move suppressors modal
    closeDeleteSuppressorsModal() {
      // reset the suppressors id
      this.suppressor = null;

      // close the modal
      this.$refs[`confirmation-delete-suppressors`].close();
    },

    
    // Function used to remove suppressor data.
    async removeSuppressorsData() {
      // show loader
      this.showLoader();

      try {
        // remove suppression data
        await deleteData(`${this.suppressorDataUrl}/${this.suppressorId}`);

        // refresh suppressors listing
        this.$refs.serverTable.$refs.suppressorsTable.refresh();
      } catch (error) {
        // show error alert
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },
  },

  computed: {
    /**
     * Returns styling for suppression import button.
     * @return {object} - styling of button.
     */
    suppressorButtonViaImport() {
      return {
        '--import-email-text': this.$t(
          'frontend_groovemail_components_suppressions_suppressors_add_suppressors_via_import'
        ),
      };
    },

    /**
     * Returns suppressors table slot data.
     * @return {array} - slot data for suppressors table 
     */
    suppressorsTableSlotData() {
      return [
        {
          slotName: 'created_at',
          slotType: 'computed',
          classes: () => '',
          value: (props) => props.row.created_at
              ? `${new Date(props.row.created_at).getDate()} ${
                  this.months[new Date(props.row.created_at).getMonth()]
                }, ${new Date(props.row.created_at).getFullYear()}`
              : this.$t('frontend_groovemail_not_available'),
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => true,
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_delete'),
              conditions: () => true,
              callback: (props) => this.openDeleteSuppressorsModal(props.row.id),
            },
          ],
        },
      ];
    },
  },
};
</script>

<style scoped>
.gm-suppression-table__surface {
  min-width: 0;
  padding: 20px;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-suppression-table__surface {
    padding: 14px;
    border-radius: var(--gs-radius-md);
  }
}
</style>
